import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AddFlaggedKitsData, FlaggedKitsPayloadListing, PayloadTypeDeleteFlaggedKits, PayloadTypeGetFlaggedKits, FlaggedKitsState, UpdateFlaggedKitsData,
} from '../utils/types';

const initialState: FlaggedKitsState = {
  FlaggedKitsData: {} as FlaggedKitsPayloadListing,
  isLoading: false,
  error: '',
  isSuccess: false,
};

const flaggedKitsSlice = createSlice({
  name: 'flaggedKits',
  initialState,
  reducers: {
    getFlaggedKitsStart(state, _action: PayloadAction<PayloadTypeGetFlaggedKits>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    successFlaggedKits(state, action: PayloadAction<FlaggedKitsPayloadListing>) {
      return {
        ...state,
        isLoading: false,
        FlaggedKitsData: action?.payload,
      };
    },
    failureFlaggedKits(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },

    updateFlaggedKits(state, _action: PayloadAction<UpdateFlaggedKitsData>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    successUpdateFlaggedKits(state) {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
      };
    },
    failureUpdateFlaggedKits(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        responseMessage: action.payload,
      };
    },
    resetState(state) {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        responseMessage: '',
      };
    },

    addFlaggedKitsStart(state, _action: PayloadAction<AddFlaggedKitsData>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    successAddFlaggedKits(state) {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
      };
    },
    failureAddFlaggedKits(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        responseMessage: action.payload,
      };
    },

    deleteFlaggedKitsStart(state, _action: PayloadAction<PayloadTypeDeleteFlaggedKits>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    successDeleteFlaggedKits(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    failureDeleteFlaggedKits(state, action: PayloadAction<string>) {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
  },

});

export const {
  getFlaggedKitsStart, successFlaggedKits, failureFlaggedKits, updateFlaggedKits,
  successUpdateFlaggedKits, failureUpdateFlaggedKits, resetState, deleteFlaggedKitsStart,
  successDeleteFlaggedKits, failureDeleteFlaggedKits,
  addFlaggedKitsStart, successAddFlaggedKits, failureAddFlaggedKits,
} = flaggedKitsSlice.actions;
export const FlaggedKitsReducer = flaggedKitsSlice.reducer;

export type FlaggedKitsTypeActions =
  | ReturnType<typeof getFlaggedKitsStart>
  | ReturnType<typeof successFlaggedKits>
  | ReturnType<typeof failureFlaggedKits>

  | ReturnType<typeof updateFlaggedKits>
  | ReturnType<typeof successUpdateFlaggedKits>
  | ReturnType<typeof resetState>
  | ReturnType<typeof failureUpdateFlaggedKits>

  | ReturnType<typeof deleteFlaggedKitsStart>
  | ReturnType<typeof successDeleteFlaggedKits>
  | ReturnType<typeof failureDeleteFlaggedKits>

  | ReturnType<typeof addFlaggedKitsStart>
  | ReturnType<typeof successAddFlaggedKits>
  | ReturnType<typeof failureAddFlaggedKits>;
